// extracted by mini-css-extract-plugin
export default {"container":"ContentArea_container__n5QhS","marginTop-0":"ContentArea_marginTop-0__x5hml","marginTop-8":"ContentArea_marginTop-8__pCha5"};